import { LinearGradient } from 'expo-linear-gradient';
import { useRouter } from 'expo-router';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
// D-018 + D-025: the persistent Upgrade CTA + trial countdown are now rendered as a
// floating card in the bottom-right on desktop (see DesktopProFloatingCard mounted in
// _layout.tsx). This header deliberately no longer carries either affordance.

const DesktopHeader = ({ logo: LogoComponent, navLinks, onSearchPress, onAddCarPress, onLogoPress, variant = 'light', activeRoute, hideUpgradeCTA = false }) => {
  const router = useRouter();
  const isDark = variant === 'dark';

  const handlePress = (item) => {
    if (item.onPress) {
      item.onPress();
    } else if (item.target) {
      router.push(item.target);
    }
  };

  return (
    <View style={[styles.headerContainer, isDark && styles.headerContainerDark]}>
      {/* Desktop Logo */}
      <View>
        {LogoComponent &&
          (onLogoPress ? (
            <TouchableOpacity onPress={onLogoPress}>
              <View style={isDark ? undefined : { filter: 'invert(1)' }}>
                <LogoComponent width={100} height={28} />
              </View>
            </TouchableOpacity>
          ) : (
            <View style={isDark ? undefined : { filter: 'invert(1)' }}>
              <LogoComponent width={100} height={28} />
            </View>
          ))}
      </View>
      {/* Desktop Header Bar */}
      <View style={styles.headerBar}>
        {navLinks && navLinks.length > 0 && (
          <View style={styles.navLinksContainer}>
            {navLinks.map((link, index) => {
              const isActive = activeRoute && link.target === activeRoute;
              return (
                <TouchableOpacity key={index} onPress={() => handlePress(link)} style={styles.navLinkWrapper}>
                  <Text
                    style={[
                      styles.navLinkText,
                      isDark && styles.navLinkTextDark,
                      isDark && isActive && styles.navLinkTextDarkActive,
                    ]}
                  >
                    {link.title}
                  </Text>
                  {link.badge > 0 && (
                    <View style={styles.badgeContainer}>
                      <Text style={styles.badgeText}>{link.badge > 9 ? '9+' : link.badge}</Text>
                    </View>
                  )}
                </TouchableOpacity>
              );
            })}
          </View>
        )}
        {!isDark && onSearchPress && (
          <TouchableOpacity onPress={onSearchPress}>
            <LinearGradient colors={['#538AF9', '#2466ED']} style={styles.verifyCarButton}>
              <Text style={styles.verifyCarButtonText}>Search for new car</Text>
            </LinearGradient>
          </TouchableOpacity>
        )}
        {isDark && onAddCarPress && (
          <TouchableOpacity onPress={onAddCarPress} style={styles.addCarButton}>
            <Text style={styles.addCarButtonPlus}>+</Text>
            <Text style={styles.addCarButtonText}>Add a Car</Text>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    zIndex: 100,
    paddingHorizontal: 112,
    paddingVertical: 12,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    backdropFilter: 'blur(10px)',
  },
  headerBar: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 32,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 8,
  },
  logoText: {
    color: 'rgba(10, 30, 68, 1.00)',
    fontFamily: 'Chillax Variable',
    fontSize: 40,
    fontWeight: '500',
    lineHeight: 40 * 1.01,
    letterSpacing: -2.88,
    textAlign: 'center',
    alignSelf: 'center',
  },
  navLinksContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 40,
  },
  navLinkText: {
    fontFamily: 'Satoshi-Medium',
    fontSize: 14,
    lineHeight: 22.4,
    color: '#0E0E0E',
  },
  headerContainerDark: {
    backgroundColor: 'transparent',
    backdropFilter: 'none',
    paddingHorizontal: 32,
  },
  navLinkTextDark: {
    fontFamily: 'Satoshi-Medium',
    color: 'rgba(255, 255, 255, 0.5)',
  },
  navLinkTextDarkActive: {
    fontFamily: 'Satoshi-Bold',
    color: '#FFFFFF',
    opacity: 1,
  },
  verifyCarButton: {
    paddingHorizontal: 32,
    paddingVertical: 12,
    borderRadius: 32,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
  },
  verifyCarButtonText: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 14,
    lineHeight: 22.4,
    letterSpacing: -0.14,
    color: '#FFFFFF',
  },
  addCarButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#144CB8',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 20,
    gap: 6,
  },
  addCarButtonPlus: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 16,
    color: '#FFFFFF',
    lineHeight: 16,
  },
  addCarButtonText: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 14,
    color: '#FFFFFF',
  },
  navLinkWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  badgeContainer: {
    backgroundColor: '#FF0000',
    borderRadius: 8,
    minWidth: 16,
    height: 16,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,
  },
  badgeText: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 10,
    color: '#FFFFFF',
    lineHeight: 12,
  },
});

export default DesktopHeader;
